// VFX: Odometer Stat Counter
// Category: data-viz · Tags: counter, odometer, stats, number, explainer
// Digit-wheel odometer rolling animation — YouTube milestone and explainer videos.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface OdometerCounterProps {
  value?: number;
  label?: string;
  prefix?: string;
  suffix?: string;
  color?: string;
}

const Digit: React.FC<{ digit: number; height: number; color: string }> = ({ digit, height, color }) => {
  return (
    <div style={{ height, overflow: "hidden", position: "relative", width: height * 0.6, display: "inline-block" }}>
      <div style={{ transform: `translateY(${-digit * height}px)`, transition: "none" }}>
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
          <div key={d} style={{ height, display: "flex", alignItems: "center", justifyContent: "center", fontSize: height * 0.85, fontWeight: 900, color, fontFamily: "system-ui", lineHeight: 1 }}>
            {d}
          </div>
        ))}
      </div>
    </div>
  );
};

export default function OdometerCounter({
  value = 12500,
  label = "Subscribers",
  prefix = "",
  suffix = "",
  color = "#a855f7",
}: OdometerCounterProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const p = spring({ frame, fps, config: { damping: 200, stiffness: 80, mass: 1.2 } });
  const current = Math.round(interpolate(p, [0, 1], [0, value], clamp));
  const digits = String(current).padStart(String(value).length, "0").split("").map(Number);
  const labelOp = interpolate(frame, [25, 40], [0, 1], clamp);
  return (
    <AbsoluteFill style={{ background: "#0a0e1a", justifyContent: "center", alignItems: "center", gap: 24 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {prefix && <span style={{ fontSize: 100, fontWeight: 900, color, fontFamily: "system-ui" }}>{prefix}</span>}
        {digits.map((d, i) => <Digit key={i} digit={d} height={140} color={color} />)}
        {suffix && <span style={{ fontSize: 100, fontWeight: 900, color, fontFamily: "system-ui" }}>{suffix}</span>}
      </div>
      <div style={{ fontSize: 22, color: "#94a3b8", fontFamily: "system-ui", letterSpacing: 3, textTransform: "uppercase", opacity: labelOp }}>
        {label}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
